<p-toast position="top-right"></p-toast>

<div class="root-body"
	 [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">

	<div class="flex flex-row mb-3 flex-wrap gap-2" style="align-items: center">
		<div class="head-title mr-4">
			Taxi Drivers Performance
		</div>

		<p-dropdown [options]="frequencies"
					[(ngModel)]="selectedFrequency"
					(onChange)="onFilterChange()"
					optionLabel="label"
					optionValue="value"
					[style]="{'width':'150px'}">
		</p-dropdown>

		<div class="mr-2 ml-auto">
			<p-calendar [appendTo]="'body'"
						[inputStyle]="{'height': '45px', 'background-color': 'white', 'color': 'black'}"
						selectionMode="range" [readonlyInput]="true" [showIcon]="true"
						[(ngModel)]="selectedDateRange"
						(ngModelChange)="onFilterChange()"/>
		</div>

		<div class="report-customer-header__separator"></div>

		<div class="mr-2">
			<button style="height: 35px;" class="bluedark-btn" pButton label="Export Data" icon="pi pi-download"
					(click)="op.toggle($event)"></button>

			<p-overlayPanel #op [style]="{width: '200px'}">
				<ng-template pTemplate>
					<div class="export-popup-item" (click)="exportData(exportFileTypeEnum.Excel)">
						<i class="pi pi-file-excel mr-2"></i> Download Excel
					</div>
					<div class="export-popup-item" (click)="exportData(exportFileTypeEnum.CSV)">
						<i class="pi pi-file mr-2"></i> Download CSV
					</div>
				</ng-template>
			</p-overlayPanel>
		</div>
	</div>

	<div class="card flex justify-content-center" *ngIf="isLoading">
		<p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="8" fill="var(--surface-ground)"
						   animationDuration=".5s"/>
	</div>

	<div class="card" *ngIf="!isLoading">
		<p-scrollPanel [style]="{width:'100%', height: 'calc(78vh)'}" [styleClass]="'app-scrollpanel'">
			<p-table [value]="performanceData"
					 [tableStyle]="{ 'min-width': '60rem' }"
					 [rowHover]="true"
					 sortField="DateRaw"
					 [sortOrder]="-1">
				<ng-template pTemplate="header">
					<tr>
						<th pSortableColumn="DateRaw">Date / Period
							<p-sortIcon field="DateRaw"></p-sortIcon>
						</th>
						<th pSortableColumn="AvgTripsPerDriver">Avg Trips per Driver
							<p-sortIcon field="AvgTripsPerDriver"></p-sortIcon>
						</th>
						<th pSortableColumn="AvgEarningsCash">Avg Earnings (Cash)
							<p-sortIcon field="AvgEarningsCash"></p-sortIcon>
						</th>
						<th pSortableColumn="AvgEarningsCashless">Avg Earnings (Cashless)
							<p-sortIcon field="AvgEarningsCashless"></p-sortIcon>
						</th>
						<th pSortableColumn="AvgActivityHours">Activity Hours per Driver
							<p-sortIcon field="AvgActivityHours"></p-sortIcon>
						</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-item>
					<tr>
						<td style="font-weight: 600;">{{ item.DateLabel }}</td>
						<td>{{ item.AvgTripsPerDriver }}</td>
						<td>{{ item.AvgEarningsCash | number:'1.2-2' }}</td>
						<td>{{ item.AvgEarningsCashless | number:'1.2-2' }}</td>
						<td>{{ item.AvgActivityHours }}</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="5" class="text-center p-4">No taxi performance data found for the selected range.
						</td>
					</tr>
				</ng-template>
			</p-table>
		</p-scrollPanel>
	</div>
</div>
